<template>
  <div class="noPermission-box">
    <div>
      <img :src="noPermissionImg" />
      <p>{{ text || defaultText }}</p>
    </div>
  </div>
</template>
<script>
import noPermissionImg from "@/assets/images/noPurchase.png";
export default {
  name: "noPermission",
  props: {
    text: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      noPermissionImg: noPermissionImg,
      defaultText: this.$t ? this.$t('utils.noPermissionDefault') : "抱歉，您无权限访问此页面",
    };
  },
};
</script>
<style lang="less" scoped>
.noPermission-box {
  height: 100%;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-size: 14px;
  color: #b4b5bb;

  img{
    width: 200px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/noPermission.vue